var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"aligned-territories-container"},[_c('div',{staticClass:"field-container"},[_c('label',{staticClass:"query-label"},[_vm._v(" "+_vm._s(_vm.$t("includeChildTerritories"))+" ")]),_c('div',{staticClass:"selection"},[_vm._v(" "+_vm._s(_vm.getChildTerritories)+" ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }